import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId) {
    ReactGA.initialize(measurementId, {
      gtagOptions: {
        send_page_view: false, // We'll manually track page views for better control
      },
    });
    console.log('Google Analytics initialized');
  } else {
    console.warn('Google Analytics Measurement ID not found in environment variables');
  }
};

// Track page views
export const trackPageView = (pageName) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.send({
      hitType: 'pageview',
      page: pageName,
      title: pageName
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event(eventName, eventParams);
  }
};

// Specific event trackers for common actions
export const trackModuleComplete = (organ, moduleIndex, score, xpEarned) => {
  trackEvent('module_complete', {
    organ,
    module_index: moduleIndex,
    score,
    xp_earned: xpEarned,
  });
};

export const trackGameComplete = (gameName, score, coinsEarned, xpEarned) => {
  trackEvent('game_complete', {
    game_name: gameName,
    score,
    coins_earned: coinsEarned,
    xp_earned: xpEarned,
  });
};

export const trackAvatarCustomized = (itemsEquipped) => {
  trackEvent('avatar_customized', {
    items_equipped: Object.keys(itemsEquipped).filter(key => itemsEquipped[key]).length,
  });
};

export const trackLevelUp = (oldLevel, newLevel, totalXP) => {
  trackEvent('level_up', {
    old_level: oldLevel,
    new_level: newLevel,
    total_xp: totalXP,
  });
};

export const trackUserSignup = (method) => {
  trackEvent('sign_up', {
    method, // 'email', 'google', 'github'
  });
};

export const trackUserLogin = (method) => {
  trackEvent('login', {
    method, // 'email', 'google', 'github'
  });
};
